import { useContext } from 'react';
import { WalletContext, type WalletDeps } from './WalletProvider';

export function useWallet(): WalletDeps {
  const ctx = useContext(WalletContext);
  if (!ctx) {
    throw new Error('useWallet: must be used within a WalletProvider');
  }
  return ctx;
}
